import React from 'react'

const CopyIcon16pxSvg = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
            <rect x="5.5" y="5.5" width="11" height="11" rx="2.5" stroke="#3B82F6" />
            <path d="M3 12V12C1.89543 12 1 11.1046 1 10V3C1 1.89543 1.89543 1 3 1H10C11.1046 1 12 1.89543 12 3V3" stroke="#3B82F6" strokeLinecap="round" />
        </svg>
    )
}

export default CopyIcon16pxSvg